import React, { useState, useEffect, useContext } from "react"
import { eKyc, eKycVerify } from "../../../services/ekycAndCkyc"
import EkycCkycPageStep from "./ekyc-component/ekyc-ckyc-page-step"
import EkycCkycRightSide from "./ekyc-component/ekyc-ckyc-right-side"
import { SectionContext } from "../../context/sectionContext"
import { PageContext } from "../../context/pageContext"
import { JourneyContext } from "../../context/journeyContext"
import { saveApplication, fetchAllJourneyData, updateUserTrackerDetails, verifyCaptcha } from "../../../services/apiservice"
import EkycCheckboxContent from "./ekyc-component/ekyc-checkbox-content"
import TextToSpeech from "../../common/TextToSpeech"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../../services/error-handler"
import * as lookup from "../../../../static/lookup.json"
import { isIE } from 'react-device-detect';
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { findCurrentJourneyCode } from "../../services/helperFunctions"


// Declaration text paragraphs - used for both UI rendering and text-to-speech
const EKYC_DECLARATION_PARAGRAPHS = {
  para1: `I hereby give my explicit and voluntary consent to Canara HSBC Life Insurance Company Limited ("the Company") to obtain and use my Aadhaar Number to authenticate or complete my electronic Know Your Customer (e-KYC) requirements through One Time Password (OTP) received by me/ my biometrics with the Unique Identification Authority of India (UIDAI) in connection with the Proposal Form submitted by me, which will include but not limited to the issuance of the Insurance Policy and resultant service requests ("Purpose").`,
  para2: `I acknowledge that my Aadhaar details will be submitted to the Central Identities Data Repository (CIDR) for the purpose of authentication and that upon authentication, UIDAI may share my Aadhaar information in the nature of demographic information including my photograph with the Company as an identity and/or address proof for the above purpose which might be further retained for a period specified under applicable laws & regulations.`,
  para3: `I understand that (a)Apart from Aadhaar there are other alternatives that can be submitted as proof of identity and address (b) Aadhaar information shall not be used for any purpose other than those mentioned herein or as per requirements of law (c) Biometric details will not be stored by the Company and (d) Aadhaar information will not be shared with any third party except as provide under applicable law(s)`,
  para4: `I hereby declare and confirm that all the information furnished by me is true correct and complete I will not hold the Company or its officials responsible in case of any incorrect information provided by me.`
}

// Combined full text for text-to-speech
const EKYC_DECLARATION_FULL_TEXT = `${EKYC_DECLARATION_PARAGRAPHS.para1} ${EKYC_DECLARATION_PARAGRAPHS.para2} ${EKYC_DECLARATION_PARAGRAPHS.para3} ${EKYC_DECLARATION_PARAGRAPHS.para4}`


const Ekyc = props => {
  

  const [showModal, setShowModal] = useState(false)
  const [ekycObj, setEkycObj] = useState({})
  const [checked, setChecked] = useState(false)
  const [authType, setAuthType] = useState("OM")
  const [verifyEKycData, setVerifyEKycData] = useState({
    ekycvalue: "LA",
  })
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [resetOtpCounter, setResetOtpCounter] = useState(0)
  const [showResendOtpButton, setShowResentOtpButton] = useState(false)
  const [maskedAdharNumber, setMaskedAdharNumber] = useState("")
  const [alreadyEkycVerified, setAlreadyEkycVerified] = useState(false)
  const [timer,setTimer] = useState(30);
  const [clickType, setClickType]=useState(true);
  const [isclick, setisClick]=useState(false);
  const [otpSent,setOtpSent] = useState(false)
  const [otp,setOtp] = useState(true)

  const [errors, setErrors] = useState({
    aadharNo: "Please enter Aadhar Number",
  })
  const [showError, setShowError] = useState({})
  const [resendVal, setResendVal] = useState()
  var authType1;
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleKeyPress = (e)=>{
    if (e.charCode == 13){
      return true;
    }else{
      return false;
    }
  }

  useEffect(() => {
    const timerCounter = timer > 0 && setInterval(() => { console.log('as'); setTimer(timer -1)}, 1000)
    return () => clearInterval(timerCounter)
  },[timer]);

  useEffect(async () => {
    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
    }
    let journeyResult = await fetchAllJourneyData(payload)
    console.log(journeyResult, "asdsadas")
    if(journeyResult?.lifeAssuredDetails?.kycVerified === true){
      props.setCurrentSectionIndex(prev => prev + 1)
      setMaskedAdharNumber(journeyResult.lifeAssuredDetails?.kycDetails?.maskAdhaarNumber)
      setAlreadyEkycVerified(true)
    }else if(journeyResult?.lifeAssuredDetails?.kycVerified === false){
      setEkycObj(prev => {
        return ({
          ...prev,
          ["aadharNo"]: journeyResult?.lifeAssuredDetails?.aadharEntered
        })
      })
    }
  }, [])

  const validate = (target, name) => {
    if (name === "aadharNo") {
      if (!target.value) {
        setErrors(prev => {
          return {
            ...prev,
            [name]: "Please enter Aadhar Number",
          }
        })
        setShowError(prev => {
          return {
            ...prev,
            [name]: true,
          }
        })
        setEkycObj(oldItem => {
          return {
            ...oldItem,
            [name]: target.value,
          }
        })
      } else if (target.value.length < 12) {
        setErrors(prev => {
          return {
            ...prev,
            [name]: "Please enter a valid Aadhaar number or VID",
          }
        })
        setShowError(prev => {
          return {
            ...prev,
            [name]: true,
          }
        })
      } else if (target.value.length > 12 && target.value.length < 16) {
        setErrors(prev => {
          return {
            ...prev,
            [name]: "Please enter a valid Aadhaar number or VID",
          }
        })
        setShowError(prev => {
          return {
            ...prev,
            [name]: true,
          }
        })
      } else {
        setErrors(prev => {
          return {
            ...prev,
            [name]: "",
          }
        })
      }
    } else if (name === "otp2") {
      if (!target.value || target?.value.length === 0) {
        setErrors(prev => {
          return {
            ...prev,
            [name]: "Please enter OTP",
          }
        })
        setShowError(prev => {
          return {
            ...prev,
            [name]: true,
          }
        })
      }
      if (target.value.length < 6) {
        setErrors(prev => {
          return {
            ...prev,
            [name]: "Please enter a valid OTP",
          }
        })
        setShowError(true)
        return
      }
      else{
        setErrors(prev => {
          return {
            ...prev,
            [name]: "",
          }
        })
        setShowError(true)
      }
      if(target.value){
        let regex = "/^[0-9]+$/"
        let rg = regex.substring(1, regex.lastIndexOf('/'))
        let flags = regex.substring(regex.lastIndexOf('/') + 1)
        let regex_exp = new RegExp(rg, flags)
        if (!regex_exp.test(target.value)) {
          setErrors(prev => {
            return {
              ...prev,
              [name]: "Please enter valid OTP",
            }
          })
          return
        }
      else{
        setErrors(prev => {
          return {
            ...prev,
            [name]: "",
          }
        })
        setShowError(true)
      }
      setShowError(true)
    }
    }
  }

  const changeInputToMask = ({ target }, name) => {
    console.log(target)
   if(name === "Mask"){ 
    if(target.value.length === 12 || target.value.length === 16){
      let aadharNumber = target.value
      let mask = target.value.slice(8)
      let maskAdharValue = `XXXXXX${mask}`
      setEkycObj(oldItem => {
        return {
          ...oldItem,
          ["aadharNoValue"]: maskAdharValue,
        }
      })
      }
    }else {
      let nonMask = ekycObj?.aadharNo || target.value
      setEkycObj(oldItem => {
        return {
          ...oldItem,
          ["aadharNoValue"]: nonMask,
        }
      })
    }
  }

  const changeInput = ({ target }, name) => {
    console.log(target, "fdfgrgrfgr1")
    if (name === "aadharNo") {
      if (!isNaN(target.value)) {
        setEkycObj(oldItem => {
          return {
            ...oldItem,
            [name]: target.value,
            ["aadharNoValue"]: target.value,
          }
        })
      }
    } else {
        setVerifyEKycData(prev => {
          return {
            ...prev,
            authCode: target.value,
          }
        })
        if (target.value.length === 6) {
          document.getElementById("submitBtn").disabled = false
        }
    }
    validate(target, name)
    console.log(ekycObj, "fdfgrgrfgr2")
  }

  useEffect(() => {
    const timer =
      resetOtpCounter > 0 &&
      setInterval(() => setResetOtpCounter(resetOtpCounter - 1), 1000)
    return () => clearInterval(timer)
  }, [resetOtpCounter])

  const authTypeClick = (ev, type) => {
    if(alreadyEkycVerified){
      return 
    }

    if (
      (ekycObj && ekycObj?.aadharNo && ekycObj?.aadharNo?.length === 12) ||
      ekycObj?.aadharNo?.length === 16
    ) {
        if(isclick){
          if (type === "OM") {
            if (!(document.getElementById("mobileOtp").classList.contains("active"))) {
              document.getElementById("mobileOtp").classList.add("active")
            }
            document.getElementById("emailOtp").classList.remove("active")
              setAuthType("OM")
              authType1 = "OM";
              journeyState['ekycAuthType'] = "OM"
              setResendVal("resendOM");
              if (
                document.getElementById("hiddenOTPField").classList.contains("hidden")
              ) {
                document.getElementById("hiddenOTPField").classList.remove("hidden")
              }
              aadharOtp(ev,"button")
          } else {
            if (!(document.getElementById("emailOtp").classList.contains("active"))) {
              document.getElementById("emailOtp").classList.add("active")
            }
            document.getElementById("mobileOtp").classList.remove("active")
            setAuthType("OE")
            authType1 = "OE";
            journeyState['ekycAuthType'] = "OE";
            setResendVal("resendOE");
            if (
              document.getElementById("hiddenOTPField").classList.contains("hidden")
            ) {
              document.getElementById("hiddenOTPField").classList.remove("hidden")
            }
            aadharOtp(ev,"button")
          }
        } else{
          errorToastr("Please provide your consent to proceed further")
          return
        }
     } else {
        setShowError({
          aadharNo: true,
        })
      }
    }

  const aadharOtp = (e,dt) => {
    e.preventDefault();
    if ((ekycObj && ekycObj?.aadharNo && ekycObj?.aadharNo.length === 12) ||
      ekycObj?.aadharNo?.length === 16){
      if(ekycObj.aadharNo && journeyState.ekycAuthType){
        const data = {uuid: ekycObj.aadharNo}
        data['authType'] = journeyState.ekycAuthType;
        data['module'] = "LA"
        data['journeyId'] = journeyState.journeyId
        data['applicationNumber'] = journeyState.applicationNo
        if(dt==="button"){
          setShowResentOtpButton(true);
          setOtpSent(true)
          console.log(otpSent);
        }else{
          setShowResentOtpButton(false);
          // setOtpSent(false)
          console.log(otpSent);
        }
        eKyc(data)
          .then(res => {
            console.log(resendVal)
            console.log(authType1)
            // console.log(authType);
            if(dt === "button"){
              setResetOtpCounter(0);
              setTimer(0);
            }else{
              setResetOtpCounter(30);
            }
            if (res.status && res.data.RESULT.OTP_FLAG === "y") {
              setVerifyEKycData(prev => {
                return {
                  ...prev,
                  uidNo: ekycObj.aadharNo,
                  transactionId: res.data.RESULT.TRANSACTION_ID,
                  otpTrCode: res.data.RESULT.TRANSACTION_ID,
                  authType: "O",
                  journeyId: journeyState.journeyId,
                  applicationNumber: journeyState.applicationNo,
                }
              })
            }
            if (res.data.STATUS === "ERROR") {
              if (res?.data?.CODE && lookup["kycErrorCode"][0][res?.data?.CODE]) {
                console.log(lookup["kycErrorCode"][0][res.data.CODE])
                if(res?.data?.CODE === "115"){
                  if(journeyState.ekycAuthType === "OM"){
                    errorToastr("Mobile number is not registered. Please try email option",10000,'big');
                  }else{
                    errorToastr("Email ID is not registered. Please try mobile number option",10000,'big');
                  }
                }else{
                  errorToastr(lookup["kycErrorCode"][0][res.data.CODE],10000,'big')
                }
              } else {
                errorToastr(
                  "Due to technical reasons, unable to send OTP. Please contact system administrator",10000,'big'
                )
              }
            } else {
              if (journeyState.ekycAuthType === "OM") {
                if (resendVal && resendVal === "resendOM" && dt=='resend') {
                  successToastr(
                    "OTP is sent to your registered mobile number/e-mail ID"
                  )
                  // successToastr(
                  //   "OTP has been resent to your registered mobile number. The OTP will expire in 10 minutes"
                  // )
                } else {
                  successToastr(
                    "OTP has been successfully sent to your registered mobile number. The OTP will expire in 10 minutes"
                  )
                  // successToastr(
                  //   "OTP has been successfully sent to your registered mobile number. The OTP will expire in 10 minutes"
                  // )
                }
              } else {
                if (resendVal && resendVal === "resendOE" && dt=='resend') {
                  // successToastr(
                  //   "OTP has been resent to your registered Email ID. The OTP will expire in 10 minutes"
                  // )
                  successToastr(
                    "OTP is sent to your registered mobile number/e-mail ID"
                  )
                } else {
                  successToastr(
                    "OTP has been successfully sent to your registered Email ID. The OTP will expire in 10 minutes"
                  )
                  // successToastr(
                  //   "OTP has been successfully sent to your registered Email ID. The OTP will expire in 10 minutes"
                  // )
                }
              }
            }
            if(dt=="resend"){
              setTimeout(() => {
                setShowResentOtpButton(true)
              }, 30000);
              setTimer(30);
            }
          })
          .catch(error => {
            console.log(error)
            // this.setState({ datafetching: false, datafetcherror: true })
        })
      }
    }else {
      setShowError({
        aadharNo: true,
      })
    }
   
  }

  const submitAadharVerfication = (ev, val) => {
    if(ekycObj && ekycObj.aadharNo === null){
      setShowError({
        aadharNo: true,
      })
    }
    else if(verifyEKycData && !verifyEKycData.authCode){
      setErrors(prev => {
        return {
          ...prev,
          ["otp2"]: "Please enter OTP",
        }
      })
      setShowError(true)
    }
    console.log(showError, errors)
    ev.preventDefault()
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Aadhar Submit ", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in submitAadharVerfication:", error);
    }
    if(alreadyEkycVerified){
      props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          lastPageCode: props.pageId,
          lastSectionCode:
            props.sections[props.currentSectionIndex + 1].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex + 1].sectionId
          ),
        }
      })
      return
    }
    // if ((val = "showModal")) {
      setShowModal(true)
    // }
    console.log(verifyEKycData)
    if ((ekycObj && ekycObj?.aadharNo && (ekycObj?.aadharNo.length === 12) ||
    ekycObj?.aadharNo?.length === 16) && verifyEKycData && verifyEKycData.authCode && verifyEKycData.authCode.length === 6){
    eKycVerify(verifyEKycData)
      .then(res => {
        if (res.data.STATUS === "ERROR") {
          errorToastr(lookup["otpErrorCode"][0][res.data.CODE],10000,'big')
        } else {
          successToastr("EKYC verification is successfull")
          let sendPayload = {
            applicationData: journeyState.journeyData,
            journeyData: {
              _id: journeyState.journeyId,
              lastPage: props.currentPageIndex,
              lastSection: props.currentSectionIndex,
              applicationNo: journeyState.applicationNo,
              illustrationNumber: journeyState.illustrationNumber,
              proposalEntryId: journeyState.proposalEntryId,
              lastPageCode: props.pageId,
              planOption: journeyState.planOption,
              lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
            },
          }

          setTimeout(() => {
            saveApplication(sendPayload).then(res => {
              console.log(res, "application response")
              // condition of same page
              props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
              setJourneyState(prev => {
                return {
                  ...prev,
                  lastPage: props.currentPageIndex,
                  lastSection: props.currentSectionIndex + 1,
                  lastPageCode: props.pageId,
                  lastSectionCode:
                    props.sections[props.currentSectionIndex + 1].sectionId,
                  journeyCode: findCurrentJourneyCode(
                    props.pageId,
                    props.sections[props.currentSectionIndex + 1].sectionId
                  ),
                }
              })
              clearToastr()
            }).catch(err => {
              console.log(err, "err in saveApplication")
            })
          }, 2500)
        }
      })
      .catch(error => {
        console.log(error)
      })
    }

    if (journeyState.applicationNo) {
      executeRecaptcha("submit_form")
        .then(token => {
          verifyCaptcha({
            token: token,
            applicationNumber: journeyState.applicationNo,
            sectionId: "ekycSection",
            pageId: "BIPage",
          })
            .then(res => {
              console.info(res)
            })
            .catch(err => {
              console.info(err)
            })
        })
        .catch(err => {
          console.info(err)
        })
    }
  }

  const checkDisabled = () => {
    if(alreadyEkycVerified){
      return true
    }
    if (
      verifyEKycData.authCode &&
      verifyEKycData.authCode.length === 6 &&
      ekycObj.aadharNo.length === 12 &&
      checked
    ) {
      return true
    } else {
      return false
    }
  }

  const handleSkip = () => {
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Skip EKYC", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
        if (journeyState.applicationNo) {
          executeRecaptcha("submit_form")
            .then(token => {
              verifyCaptcha({
                token: token,
                applicationNumber: journeyState.applicationNo,
                sectionId: "ekycSection",
                pageId: "BIPage",
              })
                .then(res => {
                  console.info(res)
                })
                .catch(err => {
                  console.info(err)
                })
            })
            .catch(err => {
              console.info(err)
            })
        }
    } catch (error) {
      console.error("Error in handleSkip:", error);
    }

    if(alreadyEkycVerified){
      props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          lastPageCode: props.pageId,
          lastSectionCode:
            props.sections[props.currentSectionIndex + 1].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex + 1].sectionId
          ),
        }
      })
      return 
    }else{
      let sendPayload = {
        applicationData: journeyState.journeyData,
        journeyData: {
          _id: journeyState.journeyId,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex + 1,
          applicationNo: journeyState.applicationNo,
          illustrationNumber: journeyState.illustrationNumber,
          proposalEntryId: journeyState.proposalEntryId,
          lastPageCode: props.pageId,
          planOption: journeyState.planOption,
          ekycSkip: true,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId
        },
      }
      saveApplication(sendPayload).then(res => {
        console.log(res, "application response")
        // condition of same page
        props.setCurrentSectionIndex(prev => prev + 1) // this moves to next section on same page
  
        setJourneyState(prev => {
          return {
            ...prev,
            lastPage: props.currentPageIndex,
            lastSection: props.currentSectionIndex + 1,
            lastPageCode: props.pageId,
            lastSectionCode:
              props.sections[props.currentSectionIndex + 1].sectionId,
            journeyCode: findCurrentJourneyCode(
              props.pageId,
              props.sections[props.currentSectionIndex + 1].sectionId
            ),
          }
        })
      }).catch(err => {
        console.log(err, "err in saveApplication")
      })
    }
  }

  const handleChange = target => {
    console.log(target)
    if(!isclick){
      setisClick(true)
    }else{
      setisClick(false)
    }
  }
  // code of tab enter
  const handleEnterType = (event,type) =>{
    if(event?.key == 'Enter'){
      authTypeClick(event,type);
    }
  }

  // code of tab enter
  const handleEnterResendOTP = (event) =>{
    if(event?.key == 'Enter'){
      aadharOtp(event, event.target.id);
    }
  }


  return (
    <>
      <style>
        {`
            .threetabs ul li:nth-child(2).active, .threetabs ul li:nth-child(3).active, .threetabs ul li:nth-child(4).active{
                margin-left:-2px;
            }
            ::-ms-clear {
                display: none;
            }
            #more {
                display: none;
            }
            .text-danger{
                font-size:15px;
            }
            span#myBtn {
                cursor: pointer;
                left: 52px;
                position: relative;
                top: 6px;
            }
            .previous-btn,.previous-btn:hover{
              padding:0 !important;
              
            }
            .previous-btn{
              margin-left:5px
            }
            .ekycleftsidebar .col-md-9.brd-right{
              width:100% !important;
            }
            .hidden {
              display: none!important;
            }
            .but-center1{
              clear: both;
              margin: 0px;
              padding: 20px;
              display: inline-block;
              width: 100%;
              text-align: center;
            }
            @media (max-width: 992px){
              .ekycleftsidebar{
                width: 100%;
              }
              .right-box-design-size{
                width: 100%;
              }
              .iselect-smoke .col-xs-12{
                width: 100% !important;
              }
            }

        `}
      </style>
      {/* <!--body Section--> */}
      <div className="landing-page1-design">
        <div className="container">
          <div className="row">
            {/* <!--left-side--> */}
            <div className="col-md-9 ekycleftsidebar">
            <form
              onSubmit={submitAadharVerfication}
              id="OTPverify"
              name="calculatePremium"
            >
              <div className="col-md-9 brd-right">
                <div className="iselect-box-design">
                  <div className="heading-design">
                    <div className="iselect-padding left-side-head ckyc-w">
                      <h1 className="iselect-heading">
                        Provide below details for verification
                      </h1>
                    </div>
                    <div className="app-quatation nri-mt-space hidden-desktop-screen">
                      <div className="application-design-number">
                        Application Number: {journeyState.applicationNo}
                      </div>
                    </div>
                  </div>
                  <div className="iselect-padding">
                    <div className="iselect-mg-bottom ekyc-input d-flex align-items-end ekyc-test-speech">
                      <div className="col-lg-6 col-md-12 col-12 all-box-padding-right pb-0">
                        <p>
                          <strong>
                            Enter your Aadhaar Number/VID for eKYC Verification
                          </strong>
                        </p>
                        <div className="form-group">
                          <label className="title-bg inp-label">
                            Enter your Aadhaar Number/VID{" "}
                          </label>
                          <input
                            className={`form-control ${
                              errors.aadharNo && "invalid"
                            }`}
                            style={ isIE ? {lineHeight: 1} : {} }
                            type="text"
                            id="aadharNo"
                            placeholder="Enter your Aadhaar Number/VID"
                            name={+Date.now()}
                            autoComplete="new-password"
                            value={alreadyEkycVerified ? maskedAdharNumber : ekycObj.aadharNoValue}
                            onChange={(event) => {changeInput(event, "aadharNo")}}
                            disabled={alreadyEkycVerified}
                            minLength={12}
                            maxLength={16}
                            onClick={(event) => {changeInputToMask(event, "nonMask")}}
                            onBlur={(event) => {changeInputToMask(event, "Mask")}}
                          />
                          {errors.aadharNo && showError.aadharNo && (
                            <label className="input-error error">
                              {errors.aadharNo}
                            </label>
                          )}
                        </div>
                        
                      </div>
                      <div className="speaker-bottom">
                            <TextToSpeech
                              text={EKYC_DECLARATION_FULL_TEXT}
                              rate={0.9}
                              lang="en-IN"
                            />
                        </div>
                    </div>
                    <div className="iselect-mg-bottom check-design">
                      <div className="col-md-12 col-xs-12">
                        <div className="transactionDetailsWrap del-agree">
                          <div className="detailContentWrap">
                            <div className="row iAgree">
                              <div className="form-group">
                                <div className="inner-addon left-addon">
                                  <div className="checkbox1">
                                    <input
                                      id="checkboxG6"
                                      className={`css-checkbox form-control ${
                                        errors.aadharAuthenticateChecked &&
                                        "invalid"
                                      }`}
                                      type="checkbox"
                                      name="aadharAuthenticateChecked"
                                      checked={isclick}
                                      onChange={handleChange}
                                    />
                                    <EkycCheckboxContent declarationParagraphs={EKYC_DECLARATION_PARAGRAPHS} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="iselect-mg-bottom hidden-desktop-screen">
                      <div className="col-md-12 col-xs-12 iselect-smoke ekyc-otp row">
                        <div className="col-md-6 col-xs-12">
                          <div className="provider smoke-design smoke ekyc-box" id="button" tabIndex="0" onKeyPress={(ev)=>handleEnterType(ev,"OM")}>
                            <div
                              id="mobileOtp"
                              className="smoke-white-clr smoke1 s1 active"
                              aria-hidden="true"
                              onClick={e => authTypeClick(e, "OM")}
                            >
                              <p>Send OTP to registered mobile number</p>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12">
                          <div className="provider smoke-design2 smoke" id="button" tabIndex="0" onKeyPress={(ev)=>handleEnterType(ev,"OE")}>
                            <div
                              id="emailOtp"
                              className="smoke-white-clr smoke2 s2"
                              aria-hidden="true"
                              onClick={e => authTypeClick(e, "OE")}
                            >
                              <p>Send OTP to registered Email ID</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      id="hiddenOTPField"
                      className="iselect-mg-bottom aotp hidden hidden-desktop-screen"
                    >
                      <div className="col-md-6 col-xs-12 all-box-padding-right mb-20">
                        <div className="form-group">
                          <label className="title-bg inp-label ">
                            Enter One Time Password (OTP)
                          </label>
                          <input
                            className={`form-control ${
                              errors.otp2 && "invalid"
                            }`}
                            style={ isIE ? {lineHeight: 1} : {} }
                            type="text"
                            placeholder="ENTER HERE"
                            autoComplete="new-password"
                            name={+Date.now()}
                            value={verifyEKycData.authCode}
                            onChange={(event) => {changeInput(event, "otp2")}}
                            maxLength={6}
                          />
                          {errors.otp2 && (
                            <label className="error input-error">
                              {errors.otp2}
                            </label>
                          )}
                          {showResendOtpButton ? (
                            <div className="provider resend-otp eky-resend" id="resend" style={{cursor:"pointer"}} tabIndex="0" onKeyPress={(e)=>handleEnterResendOTP(e)}>
                              <a aria-hidden="true" id="resend" onClick={(e)=>aadharOtp(e,"resend")}>
                                Resend OTP
                              </a>{" "}
                              <span className="fa fa-angle-right"></span>
                            </div>
                          ) : (
                            <div className="resend-otp eky-resend">
                              <span className="fa">
                                Resending OTP in {timer} seconds
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="iselect-mg-bottom pd-bt40"></div>
                    <div className="iselect-mg-bottom hidden-desktop-screen">
                      <div className="col-md-12">
                        <div className="but-center1 text-right">
                          <div className="submit-btn cen" tabIndex="0" onKeyPress={(e) => {handleKeyPress(e); handleSkip();}}>
                            {" "}
                            <a
                              onClick={handleSkip}
                              aria-hidden="true"
                              style={{ padding: "14px 56px" }}
                            >
                              {" "}
                              Skip
                            </a>{" "}
                          </div>
                          <div
                            className="previous-btn cen"
                            // style={{
                            //   backgroundColor: `${
                            //     checkDisabled() ? "red" : "grey"
                            //   }`,
                            // }}
                          >
                            <a style={{padding:"0px"}}>
                              {" "}
                              <button
                                type="submit"
                                value="otpsubmit"
                                style={{
                                  backgroundColor: "transparent",
                                  padding: "14px 40px",
                                  margin: 0,
                                  border: "none",
                                  borderRadius:"10px",
                                  color: "#fff",
                                }}
                                id="submitBtn"
                                //disabled={checkDisabled() ? false : true}
                              >
                                Proceed
                              </button>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* <!-- </form> --> */}
                  </div>
                </div>
              </div>
              {/* <!--mobile view otp screen--> */}
              <div
                className={`otp-mobile-view-structure otpscreen`}
                style={{ zIndex: "999",left:"0px", bottom:"15px"}}
              >
                <div className="generate-otp-structure">
                  <div className="mobile-otp-icon">
                    <img src="images/mobile-otp.png" />
                  </div>

                  <div className="iselect-mg-bottom">
                  <div className="col-md-12 col-xs-12 iselect-smoke ekyc-otp">
                    <div className="col-md-6 col-xs-12">
                      <div className="smoke-design smoke ekyc-box" id="button" tabIndex="0" onKeyPress={(ev)=>handleEnterType(ev,"OM")}>
                        <div  id="mobileOtp" 
                              className="smoke-white-clr smoke1 s1 active" 
                              aria-hidden="true"
                              onClick={e => authTypeClick(e, "OM")}>
                          <p>Send OTP to registered mobile number</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 col-xs-12">
                      <div className="smoke-design2 smoke"  id="button" tabIndex="0" onKeyPress={(ev)=>handleEnterType(ev,"OE")}>
                        <div  id="mobileOtp" 
                              className="smoke-white-clr smoke1 s2" 
                              aria-hidden="true"
                              onClick={e => authTypeClick(e, "OE")}>
                          <p>Send OTP to registered Email ID</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                  {
                    /*} <p className="sent-otp">
                      {" "}
                      OTP has been sent to your registered Email ID
                    </p>*/
                    }
                </div>
                <div className="clearfix"></div>
                <div 
                  id="hiddenOTPField"
                  className="iselect-mg-bottom mt-30 enter-otp-structure aotp">
                  <div className="col-md-6 col-xs-12 all-box-padding-right">
                    <div className="form-group">
                      <label className="title-bg">Enter OTP</label>
                      <input
                            className={`form-control ${
                              errors.otp2 && "invalid"
                            }`}
                        style={ isIE ? {lineHeight: 1} : {} }
                        name={+Date.now()}
                        type="text"
                        placeholder="XXXXXX"
                        autoComplete="new-password"
                        value={verifyEKycData.authCode}
                        onChange={(event) => {changeInput(event, "otp2")}}
                        maxLength={6}
                      />
                      {errors.otp2 && (
                        <label className="error input-error">
                          {errors.otp2}
                        </label>
                      )}
                      {showResendOtpButton ? (
                        <div className="resend-otp eky-resend" style={{cursor:"pointer",marginTop:"-10px !important"}} id="resend" tabIndex="0" onKeyPress={(e)=>handleEnterResendOTP(e)}>
                          <a aria-hidden="true" id="resend" onClick={(e)=>aadharOtp(e,"resend")}>Resend OTP</a>{" "}
                          <span className="fa fa-angle-right"></span>
                        </div>
                      ) : ( otpSent&&
                        <div className="resend-otp eky-resend">
                          <span className="fa">
                            Resending OTP in {timer} seconds
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {/* <!--mobile view otp screen--> */}
            </form>
            </div>
            {/* <!--left-side--> */}

            {/* <!--right-side--> */}
            <EkycCkycRightSide />
            {/* <!--right-side--> */}
          </div>
        </div>
      </div>

      {/* <!--body Section--> */}
      <div className="clearfix"></div>

      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure otp">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen">
                {" "}
                <a aria-hidden="true" onClick={handleSkip}> Skip </a>{" "}
              </div>
              <div className="previous-btn cen">
                <a>
                  {" "}
                  <button
                    type="submit"
                    // form="OTPverify"
                    style={{
                      backgroundColor: "transparent",
                      padding: "14px 10px",
                      border: "none",
                      color: "#fff",
                    }}
                    onClick={submitAadharVerfication}
                  >
                    Submit
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button--> */}

      {/* <!--mobile view button--> */}
      <div className="mobile-view-btn-Q1 pd-mobile-space-structure otp2 hidden">
        <div className="iselect-mg-bottom">
          <div className="col-md-12">
            <div className="but-center text-center">
              <div className="submit-btn cen">
                {" "}
                <a aria-hidden="true" onClick={handleSkip}> Skip </a>{" "}
              </div>
              <div className="previous-btn cen" style={{ padding: "0" }}>
                <a>
                  {" "}
                  <button
                    type="submit"
                    value="otpsubmit"
                    name="otpsubmit"
                    form="OTPverify"
                    style={{
                      backgroundColor: "transparent",
                      padding: "0px 10px",
                      border: "none",
                      color: "#fff",
                    }}
                    onClick={e => {
                      submitAadharVerfication(e, "showModal")
                    }}
                  >
                    Submit
                  </button>{" "}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!--mobile view button--> */}
    </>
  )
}

export default Ekyc
